import api from './client';
import { User } from '../types';

export const login = (email: string, password: string) =>
  api.post<{ access: string; refresh: string; user: User }>('/auth/login/', { email, password });

export const getMe = () => api.get<User>('/auth/me/');

export const getUsers = (params?: any) => api.get('/auth/users/', { params });

export const getSubAgents = () => api.get('/auth/sub-agents/');

export const createUser = (data: any) => api.post('/auth/users/', data);

export const updateUser = (id: string, data: any) => api.patch(`/auth/users/${id}/`, data);
